<ng-container *ngIf="dropDownView; else inlineSelect">
    <drop-down-list [ngModel]="currentLocale" (valueChanges)="onLocaleChange($event)">
        <list-option *ngFor="let locale of locales" [label]="locale.label" [value]="locale.value" [icon]="locale.icon"></list-option>
    </drop-down-list>
</ng-container>
<ng-template #inlineSelect>
    <inline-select
        class="save-filter__select"
        [ngModel]="currentLocale"
        (valueChanges)="onLocaleChange($event)"
        [class.block-loading]="loading$ | async"
        ngDefaultControl
    >
        <list-option *ngFor="let locale of locales" [label]="locale.label" [value]="locale.value" [icon]="locale.icon"></list-option>
    </inline-select>
</ng-template>
